export default {
  dismissGuideCard(context) {
    return this.dispatch('api/dismissQuickstartGuideCard').then((res) => {
      context.commit('SET_PROGRESS', res.data);
    });
  },
};
